import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M7.2 9.5h9.6L12 14.3 7.2 9.5zm-.4-.4s0 0 0 0h0z" }));
export {
  o as ReactComponent
};
